import { useState } from "react";
import "./Tabs.css";

export default function Tabs({ tabs, defaultTab, onChange }) {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    onChange?.(tabId);
  };

  const currentTab = tabs.find((tab) => tab.id === activeTab);

  return (
    <div className="tabs">
      <div className="tabs-header">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
            disabled={tab.disabled}
            onClick={() => handleTabChange(tab.id)}
          >
            {tab.icon && tab.icon}
            {tab.label}
          </button>
        ))}
      </div>

      <div className="tabs-content">{currentTab?.content}</div>
    </div>
  );
}
